import { useThemeMode } from "flowbite-react";

export default function useTheme() {
  const { mode } = useThemeMode();
  return mode;
}
